import React from "react"
import { graphql } from "gatsby"
import * as styles from "./banner.module.scss"
import { BannerThematicFoldersFieldsFragment } from "../../../../graphql-types"

type BannerProps = {
  data: BannerThematicFoldersFieldsFragment
}

const Cover: React.FC<BannerProps> = ({
  data,
}) => {
  const style = {
    "--text-color": data.coverTextColor?.hex ?? "white",
    "--bg-color": data.coverBackgroundColor?.hex ?? "red",
    "--bg-image": `url(${data.coverBackgroundImage?.url ?? ""})`,
  } as React.CSSProperties
  return (
      <section className={styles.container} style={style}>
        <div className={styles.titleContainer}>
          <img src={data.coverTitle?.url ?? ""} alt={data.coverTitle.alt || ""} />
        </div>
        <span>
          <h1 className={styles.imageTitle}>
            {data.coverSubtitle}
          </h1>
        </span>
      </section>
  )
}

export const fragment = graphql`
  fragment BannerThematicFoldersFields on DatoCmsThematicFoldersPage {
    coverTitle {
      alt
      format
      title
      url
    }
    coverSubtitle
    coverTextColor {
      hex
    }
    coverBackgroundColor {
      hex
    }
    coverBackgroundImage {
      alt
      format
      title
      url
    }
  }
`

export default Cover
